import ScrollerBuilder from './ScrollerBuilder/ScrollerBuilder';

export const scrollerBuilder = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService,
  OpenGraphDataService
) =>
  reactDirective(
    ScrollerBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService,
      OpenGraphDataService
    }
  );

scrollerBuilder.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService',
  'OpenGraphDataService'
];
